module.exports = {
      id: "dislike-usage",
      viewBox: "0 0 25 23",
      url: "img/" + "sprite.svg#dislike-usage",
      toString: function () {
        return this.url;
      }
    }